export default () => ({
  status: '',
  loaded: false,
  user: null,
  masqueraded: false,
  timeZone: 'Australia/Sydney'
})
